import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useRef, useState, useEffect } from 'react';

const TruncatedText = ({ text, width = 100 }) => {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  const renderTooltip = (props) => (
    <Tooltip {...props}>{text}</Tooltip>
  );

  const content = (
    <div
      ref={textRef}
      style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: `${width}px`,
        cursor: isOverflowing ? 'pointer' : 'default',
      }}
    >
      {text}
    </div>
  );

  return isOverflowing ? (
    <OverlayTrigger placement="top" overlay={renderTooltip}>
      {content}
    </OverlayTrigger>
  ) : (
    content
  );
};

export default TruncatedText;